import autismDiagnosisQuestionSet from "../faq/autismDiagnosis/allQuestions";

export const autismDiagnosis = {
    'meta': {
        'title': 'Diagnostyka autyzmu #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Nasze Centrum zatrudnia wykwalifikowanych i doświadczonych specjalistów ds. zaburzeń spektrum autyzmu (ASD)'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/diagnostyka-autyzmu/',
        'title': 'Diagnostyka autyzmu #cityLocativeIn#',
        'name': 'Diagnostyka autyzmu #cityLocativeIn#',
        'heading': 'Diagnostyka autyzmu #cityLocativeIn#',
        'fullName': 'Diagnostyka autyzmu'
    },
    'image': {
        'url': '/images/services/diagnostyka-autyzmu-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka autyzmu #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/diagnostyka-autyzmu-w-toruniu.jpg',
            'width': 886,
            'height': 295,
            'alt': 'Diagnostyka autyzmu #cityLocativeIn#'
        }
    },
    'faq': autismDiagnosisQuestionSet
}